export const dashboardFilterOptions = Object.freeze({
  STATUS: {
    LABEL: "Status",
    placeHolder: "Status",
    options: [
      { value: "NEW", label: "NEW" },
      { value: "PRESCRIBED", label: "PRESCRIBED" },
      { value: "ASSIGNED_RX", label: "Assigned RX" },
      { value: "NO_RX", label: "No Rx" },
    ],
  },
  FIRST_TIME_USER: {
    LABEL: "First Time User",
    placeHolder: "First Time User",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
  STATE: {
    LABEL: "State",
    placeHolder: "State",
    options: [
      { value: "AL", label: "AL" },
      { value: "AK", label: "AK" },
      { value: "AZ", label: "AZ" },
      { value: "AR", label: "AR" },
      { value: "CA", label: "CA" },
      { value: "CO", label: "CO" },
      { value: "CT", label: "CT" },
      { value: "DE", label: "DE" },
      { value: "FL", label: "FL" },
      { value: "GA", label: "GA" },
      { value: "HI", label: "HI" },
      { value: "ID", label: "ID" },
      { value: "IL", label: "IL" },
      { value: "IN", label: "IN" },
      { value: "IA", label: "IA" },
      { value: "KS", label: "KS" },
      { value: "KY", label: "KY" },
      { value: "LA", label: "LA" },
      { value: "ME", label: "ME" },
      { value: "MD", label: "MD" },
      { value: "MA", label: "MA" },
      { value: "MI", label: "MI" },
      { value: "MN", label: "MN" },
      { value: "MS", label: "MS" },
      { value: "MO", label: "MO" },
      { value: "MT", label: "MT" },
      { value: "NE", label: "NE" },
      { value: "NV", label: "NV" },
      { value: "NH", label: "NH" },
      { value: "NJ", label: "NJ" },
      { value: "NM", label: "NM" },
      { value: "NY", label: "NY" },
      { value: "NC", label: "NC" },
      { value: "ND", label: "ND" },
      { value: "OH", label: "OH" },
      { value: "OK", label: "OK" },
      { value: "OR", label: "OR" },
      { value: "PA", label: "PA" },
      { value: "RI", label: "RI" },
      { value: "SC", label: "SC" },
      { value: "SD", label: "SD" },
      { value: "TN", label: "TN" },
      { value: "TX", label: "TX" },
      { value: "UT", label: "UT" },
      { value: "VT", label: "VT" },
      { value: "VA", label: "VA" },
      { value: "WA", label: "WA" },
      { value: "WV", label: "WV" },
      { value: "WI", label: "WI" },
      { value: "WY", label: "WY" },
    ],
  },
});
export const dashboardTableDesktopHeaders = (): DesktopTableHeaderOption[] => {
  return [
    {
      text: "Customer",
      span: 3,
      isCheckBox: false,
    },
    {
      text: "Address",
      span: 4,
      isCheckBox: false,
    },
    {
      text: " Pain level  & Order date",
      span: 3,
      isCheckBox: false,
    },
    {
      text: "Order # & Status",
      span: 4,
      isCheckBox: false,
    },
    {
      text: "Prescribed formula",
      span: 4,
      isCheckBox: false,
    },
    {
      text: "",
      span: 6,
      isCheckBox: true,
      checkboxId: "CHECK_ALL",
      extraClass: "put-checkbox-in-center",
    },
  ];
};

// 'REFUNDED'
